// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_cb-0";
export var actionModalContentContainer = "_cb-1";
export var createTagButton = "_cb-2";
export var footerContainer = "_cb-7";
export var fullWidthDivider = "_cb-3";
export var hasCreateTagButton = "_cb-4";
export var noCreateTagButton = "_cb-5";
export var tagsContainer = "_cb-6";
export var tagsModalContentContainer = "_cb-8";